import { storableError } from '../../util/errors';
import { initiatePrivileged } from '../../util/api';
import { fetchCurrentUser } from '../../ducks/user.duck';
import * as log from '../../util/log';

// ================ Action types ================ //

export const INITIATE_ORDER_REQUEST = 'app/MakeOfferPage/INITIATE_ORDER_REQUEST';
export const INITIATE_ORDER_SUCCESS = 'app/MakeOfferPage/INITIATE_ORDER_SUCCESS';
export const INITIATE_ORDER_ERROR = 'app/MakeOfferPage/INITIATE_ORDER_ERROR';

export const SET_INITIAL_VALUES = 'app/MakeOfferPage/SET_INITIAL_VALUES';

// ================ Reducer ================ //

const initialState = {
  initiateOrderInProgress: false,
  initiateOrderError: null,
  transaction: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case INITIATE_ORDER_REQUEST:
      return { ...state, initiateOrderInProgress: true, initiateOrderError: null };
    case INITIATE_ORDER_SUCCESS:
      return { ...state, initiateOrderInProgress: false, transaction: payload };
    case INITIATE_ORDER_ERROR:
      return { ...state, initiateOrderInProgress: false, initiateOrderError: payload };
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const initiateOrderRequest = () => ({ type: INITIATE_ORDER_REQUEST });

export const initiateOrderSuccess = transaction => ({
  type: INITIATE_ORDER_SUCCESS,
  payload: transaction,
});

export const initiateOrderError = error => ({
  type: INITIATE_ORDER_ERROR,
  payload: error,
  error: true,
});

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: initialValues,
});

// ================ Thunks ================ //

/**
 * Initiate an offer for negotiation process
 * Uses the privileged backend endpoint following official Sharetribe pattern
 */
export const initiateOrder = params => (dispatch, getState, sdk) => {
  dispatch(initiateOrderRequest());

  const { listingId, price, message } = params;

  // Order data for backend - properly structured for payment
  const orderData = {
    offerInSubunits: price,
    currency: 'USD', // ✅ CRITICAL: Add currency at root level!
    lineItems: [
      {
        code: 'line-item/item',
        unitPrice: {
          amount: price,
          currency: 'USD',
        },
        quantity: 1,
      },
    ],
  };

  // Body params for the Marketplace API call
  const bodyParams = {
    processAlias: 'default-negotiation/release-1',
    transition: 'transition/make-offer',
    params: {
      listingId,
      protectedData: {
        offerInSubunits: price,
        ...(message ? { offerMessage: message } : {}),
      },
    },
  };

  // Query params for expanding response
  const queryParams = {
    include: ['provider', 'customer', 'listing'],
    expand: true,
  };

  const requestBody = {
    isSpeculative: false,
    orderData,
    bodyParams,
    queryParams,
  };

  console.log('Sending request:', requestBody);

  return initiatePrivileged(requestBody)
    .then(response => {
      console.log('Success! Response:', response);
      
      const transaction = response.data?.data || response.data;
      
      dispatch(initiateOrderSuccess(transaction));
      dispatch(fetchCurrentUser());
      
      return transaction.id;
    })
    .catch(e => {
      console.error('Error:', e);
      
      log.error(e, 'initiate-offer-failed', {
        listingId: listingId?.uuid,
        price,
        errorMessage: e.message,
        statusCode: e.status,
      });
      dispatch(initiateOrderError(storableError(e)));
      throw e;
    });
};